import { IGridImage } from "api/interfaces/grid-image.type";
import PAImage from "component/design-system/images/PAImage";
import Link from "next/link";
import styles from "./grid-images.module.scss";

interface GridImagesProps {
   gridImages: IGridImage;
    imgSrc: string;
}

const getImageWidth = (numberOfRows: number) => {
  if (numberOfRows === 2) {
    return "300";
  }
  if (numberOfRows === 1) {
    return "100";
  }
  return "200";
};

function GridImages({
  gridImages,
  imgSrc,
}: GridImagesProps) {
  if (!gridImages?.data) {
    return null;
  }

  const imageWidth = getImageWidth(gridImages.numberOfRows);
  return (
    <div className={styles.container}>
      {
        gridImages?.data.map((item, index) => (
          (<Link
            href={item.url}
            key={index}
            className={`${styles.grid_image} ${styles[`grid_image_${imageWidth}`]}`}>

            <PAImage
              alt={item.imageUrl}
              src={`${imgSrc}${item.imageUrl}`}
              desktopHeight={`${gridImages.desktopHeight}px`}
              mobileHeight={`${gridImages.mobileHeight}px`}
            />

          </Link>)
        ))
      }
    </div>
  );
}

export { GridImages };
